import { isTouchDevice } from '../../../user/device-info';

const DrawPolygonByPoints = {};

DrawPolygonByPoints.onSetup = function() {
    this.clearSelectedFeatures();

    const feature = {
        type: 'FeatureCollection',
        properties: {},
        features: [],
    };

    const nextPoint = this.newFeature( {
        type: 'Feature',
        properties: {},
        geometry: {
            type: 'LineString',
            coordinates: [],
        },
    } );

    this.addFeature( nextPoint );

    return {
        feature: feature,
        nextPoint: nextPoint,
        currentVertexPosition: 0,
        complete: false,
    };
};

DrawPolygonByPoints.stopDrawingAndRemove = function( state, event ) {
    const silent = { silent: false };

    this.deleteFeature( [ state.nextPoint.id ], silent );

    state.feature.features.forEach( ( feature ) => {
        this.deleteFeature( [ feature.id ], silent );
    } );

    this.changeMode( 'static' );

    state.currentVertexPosition = 0;
    state.feature.features = [];
    state.complete = false;

    this.map.fire( 'draw.interrupt', {
        originalEvent: event,
    } );
};

DrawPolygonByPoints.onClick = function( state, event ) {
    if ( isTouchDevice() && event.type.startsWith( 'mouse' ) ) {
        return;
    }

    const duplicate = state.feature.features.some( ( feature ) => {
        return feature.coordinates[ 0 ] === event.lngLat.lng && feature.coordinates[ 1 ] === event.lngLat.lat;
    } );

    if ( duplicate ) {
        return;
    }

    this.map.fire( 'draw.click', {
        originalEvent: event,
    } );

    const features = this.map.queryRenderedFeatures(
        [
            event.point.x,
            event.point.y,
        ],
        {
            layers: [ 'points-are-blue.cold' ],
        },
    );

    const newPoint = {
        type: 'Feature',
        properties: {
            index: state.currentVertexPosition,
        },
        geometry: {
            type: 'Point',
            coordinates: [ event.lngLat.lng, event.lngLat.lat ],
        },
    };

    if ( features.length > 0 && state.feature.features.length >= 0 ) {
        const coordinates = [ ...this.getFeature( features[ 0 ].properties.id ).coordinates ];

        const point = state.feature.features.find( ( f ) => f.properties.index === 0 );

        const firstPointMatch = JSON.stringify( point.coordinates ) === JSON.stringify( coordinates );

        if ( firstPointMatch && state.feature.features.length >= 3 ) {
            newPoint.geometry.coordinates = [
                ...point.coordinates,
            ];

            state.complete = true;
            state.feature.features.push( this.newFeature( newPoint ) );
            return this.changeMode( 'static' );
        }

        const anyMatch = state.feature.features.some( ( f ) => JSON.stringify( f.coordinates ) === JSON.stringify( coordinates ) );

        if ( anyMatch ) {
            return;
        }
    }

    const newFeature = this.newFeature( newPoint );

    state.feature.features.push( newFeature );

    this.addFeature( newFeature );

    state.currentVertexPosition++;
};

DrawPolygonByPoints.onTap = function( state, event ) {
    this.onClick( state, event );
};

DrawPolygonByPoints.onMouseMove = function( state, event ) {
    if ( state.feature.features.length === 0 || isTouchDevice() ) {
        return;
    }

    const cursor = [ event.lngLat.lng, event.lngLat.lat ];
    const lastDrawn = state.feature.features[ state.feature.features.length - 1 ].coordinates;

    const coords = [ lastDrawn, cursor ];

    state.nextPoint.setCoordinates( coords );

    const features = this.map.queryRenderedFeatures(
        [
            event.point.x,
            event.point.y,
        ],
        {
            layers: [ 'points-are-blue.cold' ],
        },
    );

    let hoverEvent = {
        originalEvent: event,
        isFirstDrawnPoint: false,
        isDrawnPoint: false,
    };

    if ( features.length > 0 ) {
        const coordinates = [ ...this.getFeature( features[ 0 ].properties.id ).coordinates ];

        const point = state.feature.features.find( ( f ) => f.properties.index === 0 );

        const match = JSON.stringify( point.coordinates ) === JSON.stringify( coordinates );

        if ( match && state.feature.features.length >= 3 ) {
            hoverEvent.isFirstDrawnPoint = true;
        }

        hoverEvent.isDrawnPoint = true;
    }

    this.map.fire( 'draw.mousemove', hoverEvent );
};

DrawPolygonByPoints.onStop = function( state ) {
    if ( state.feature && state.complete ) {
        this.map.fire( 'draw.create', {
            features: [ {
                type: 'Feature',
                properties: {},
                geometry: {
                    type: 'Polygon',
                    coordinates: [
                        [
                            ...state.feature.features.map( ( f ) => f.coordinates ),
                        ],
                    ],
                },
            } ],
        } );
    }
};

DrawPolygonByPoints.toDisplayFeatures = function( state, geojson, display ) {
    display( {
        type: 'Feature',
        properties: geojson.properties,
        geometry: {
            type: 'LineString',
            coordinates: [
                ...state.feature.features.map( ( f ) => f.coordinates ),
            ],
        },
    } );

    return display( geojson );
};

DrawPolygonByPoints.onTrash = function() {
    DrawPolygonByPoints.stopDrawingAndRemove();
};

DrawPolygonByPoints.onKeyUp = function( state, e ) {
    if ( e.code === 'Escape' || e.code === 'Enter' ) {
        return this.stopDrawingAndRemove( state, e );
    }
};

export default DrawPolygonByPoints;
